import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";

import { GET_GITHUB_ENTERPRISE_WEBHOOKS_ENDPOINT } from "./gql";

const useGetGitHunEnterpriseWebhooksEndpoint = () => {
  const [githubEnterpriseWebhooksEndpoint, { data }] = useLazyQuery(
    GET_GITHUB_ENTERPRISE_WEBHOOKS_ENDPOINT
  );

  const generateWebhookUrl = useCallback(
    (id?: string) => {
      githubEnterpriseWebhooksEndpoint({
        ...(id && {
          variables: {
            id,
          },
        }),
      });
    },
    [githubEnterpriseWebhooksEndpoint]
  );

  return {
    webhookUrl: data?.githubEnterpriseWebhooksEndpoint,
    generateWebhookUrl,
  };
};

export default useGetGitHunEnterpriseWebhooksEndpoint;
